import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/search';
import {suggestionsPlugin, triggerCharacter} from './suggestionsPlugin';
import isEmpty from 'lodash/isEmpty';

const pagesTrigger = function () {
    return $position => {
        const parent = $position.parent;
        if (parent && ['code_block'].includes(parent.type.name)) {
          return;
        }

        try {
          return triggerCharacter("\\[\\[", {allowSpaces: true})($position);
        } catch (e) {}
    }
}

const applySearch = function (view, range, result) {
    if (view.composing) {
      return;
    }

    const state = view.state;
    const {from, to} = range;
    const title = isEmpty(result.title) ? 'Untitled' : result.title;

    const tr = state.tr
    .replaceWith(from, to, view.state.schema.text(title))
    .addMark(from, from + title.length, state.schema.marks.link.create({
      href: result.value
    }));
    view.dispatch(tr);
    view.focus();
}

const searchPages = function (view, range, text) {
    let pageList = document.getElementById('page-search-tooltip');
    if (!pageList) {
        pageList = document.createElement("div");
        pageList.id = 'page-search-tooltip';
        pageList.className = 'ui search tiny active focus scrolling long';
        pageList.innerHTML = '<input class="prompt" type="text" style="display: none"><div class="results"></div>';

        view.dom.parentNode.appendChild(pageList);
    }

    $(pageList).search({
      transition: 'scale',
      duration: 0,
      showNoResults: false,
      apiSettings: {
        url: '/api/search/pages?query={query}',
        onResponse: searchResponse => {
          const results = searchResponse.content.map(page => ({
            title: isEmpty(page.title) ? 'Untitled' : page.title,
            description: isEmpty(page.snippetHtml) ? '' : page.snippetHtml,
            value: `/pages/${page.id}`
          }));

          return {results};
        },
      },
      onSelect: result => applySearch(view, range, result),
    }).search('search remote', text);

    const {from} = range;
    const start = view.coordsAtPos(from);
    const {left: boxLeft, bottom: boxBottom} = pageList.offsetParent.getBoundingClientRect();

    pageList.style.left = start.left - boxLeft + "px";
    pageList.style.bottom = (boxBottom - start.bottom) + "px";
}

export const pageSuggestions = suggestionsPlugin({
    matcher: pagesTrigger(),
    onEnter({view, range, text}) {
        searchPages(view, range, text.slice(2));
        return false;
    },
    onChange({view, range, text}) {
        searchPages(view, range, text.slice(2));
        return false;
    },
    onExit() {
        const $pageSearchTooltip = $('#page-search-tooltip');
        if ($pageSearchTooltip.search('is visible')) {
            const keyEvent = $.Event('keydown');
            keyEvent.which = 27;
            $pageSearchTooltip.find('input').trigger(keyEvent);
            return true;
        }
        return false;
    },
    onKeyDown({view, event}) {
        if (event.key === "Backspace") {
          setTimeout(() => {
            const $position = view.state.selection.$from;
            const match = pagesTrigger()($position);
            if (match) {
              searchPages(view, match.range, match.text.slice(2));
            }
            return null;
          });
        }

        const $pageSearchTooltip = $('#page-search-tooltip');
        if ($pageSearchTooltip.search('is visible') && ['Tab', 'PageUp', 'PageDown', 'Escape', 'ArrowUp', 'ArrowDown', 'Enter'].includes(event.key)) {
            const keyEvent = $.Event('keydown');
            keyEvent.which = event.keyCode;
            $pageSearchTooltip.find('input').trigger(keyEvent);
            return true;
        }
        return false;
    }
});